module.exports = __webpack_public_path__ + "img/ranking-tow.bf600cd5.png";